import '.c8{position:relative;}.ssr-plugin'
import '.q{width:100%;}.ssr-plugin'
import '.g9{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.by{align-items:flex-start;}.ssr-plugin'
import '.s{padding:2rem;}.ssr-plugin'
import '.cf{background:var(--palette-white);}.ssr-plugin'
import '.ai{overflow:hidden;}.ssr-plugin'
import '.az{position:absolute;}.ssr-plugin'
import '.ik{top:50%;}.ssr-plugin'
import '.il{right:1rem;}.ssr-plugin'
import '.im{transform:translateY(-50%);}.ssr-plugin'
import '.in{width:120px;}.ssr-plugin'
import '.io{height:120px;}.ssr-plugin'
import '.ip{z-index:0;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.hp{z-index:1;}.ssr-plugin'
import '.an{gap:0.5rem;}.ssr-plugin'
import '.iq{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="c8 q g9 a e b by s cf ai"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="az ik il im in io ip a f b"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="c8 hp a e by an iq"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--brand-secondary)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
